// Niche news client helpers. Interests: users/<uid>/newsInterests = { <key>: "<label>" }.
// Articles: newsCache/<key> = { label, updatedAt, articles: [...] } (written only by the daily refresh function).
export function interestKey(term) {
  return String(term || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
}

// Turn the stored object into a sorted [{ key, label }] list.
export function interestList(raw) {
  if (!raw || typeof raw !== 'object') return [];
  return Object.entries(raw)
    .filter(([, v]) => typeof v === 'string' && v.trim())
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}

// Merge cached articles for the user's interests, newest first, deduped by link.
export function mergeArticles(interests, cacheByKey, filterKey = 'all') {
  const seen = new Set();
  const out = [];
  for (const { key, label } of interests) {
    if (filterKey !== 'all' && filterKey !== key) continue;
    const arts = (cacheByKey[key] && Array.isArray(cacheByKey[key].articles)) ? cacheByKey[key].articles : [];
    for (const a of arts) {
      if (!a || !a.link || !/^https?:\/\//.test(a.link) || seen.has(a.link)) continue;
      seen.add(a.link);
      out.push({ ...a, interest: label, interestKey: key });
    }
  }
  return out.sort((x, y) => (y.publishedAt || 0) - (x.publishedAt || 0));
}

export const TOP_NEWS_COUNT = 7;
const RECENT_MS = 14 * 24 * 60 * 60 * 1000;

// The short list shown on the dashboard: recent articles only, taking turns across
// interests (newest from each first) so one busy topic can't crowd out the rest.
export function topArticles(articles, max = TOP_NEWS_COUNT, now = Date.now()) {
  const recent = articles.filter((a) => !a.publishedAt || now - a.publishedAt <= RECENT_MS);
  const byInterest = new Map();
  for (const a of recent) {
    if (!byInterest.has(a.interestKey)) byInterest.set(a.interestKey, []);
    byInterest.get(a.interestKey).push(a);
  }
  const queues = [...byInterest.values()];
  const out = [];
  for (let round = 0; out.length < max && queues.some((q) => q.length > round); round += 1) {
    for (const q of queues) { if (q[round] && out.length < max) out.push(q[round]); }
  }
  return out.sort((x, y) => (y.publishedAt || 0) - (x.publishedAt || 0));
}

export function formatNewsDate(ms) {
  if (!ms) return '';
  return new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(ms));
}
